module.exports = __webpack_public_path__ + "app_icon.6f72ffad.svg";